export default "<div class=\"corridor-padding\">\n    <svg width=\"990\" height=\"500\" id=\"svg6\">\n    </svg>\n    </div>"